module.exports = __webpack_public_path__ + "static/img/purple2_tr.c6d0b0d9.png";